import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "video-process-preview-items" }
const _hoisted_2 = { class: "video-process-preview-items__bar" }
const _hoisted_3 = { class: "control-m" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "video-process-preview-items__content" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NInfiniteScroll = _resolveComponent("NInfiniteScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.items.length) + " " + _toDisplayString(_ctx.$t('videos.in_total')), 1)
    ]),
    _hoisted_4,
    _createVNode(_component_NInfiniteScroll, {
      onLoadMore: _cache[0] || (_cache[0] = () => _ctx.module.append())
    })
  ]))
}